import { Download } from 'react-feather';
import { useTranslation } from 'react-i18next';

import GetInvoicesReportQuery from './GetInvoicesReportQuery';
import UI from '../../common/UI';
import useLocale from '../../common/useLocale';
import useMediaDevice from '../../common/useMediaDevice';
import useProject from '../useProject';
import useQuery from '../../api/useQuery';
import useUrlState from '../../common/useUrlState';

const InvoicesReport = () => {
  const { t } = useTranslation();
  const { formatCurrency, formatDate, parseDate } = useLocale();
  const device = useMediaDevice();
  const project = useProject();

  const { data } = useQuery(GetInvoicesReportQuery, {
    variables: {
      project: project.id,
    },
  });

  const [urlState] = useUrlState({
    parse: (params, { integer }) => ({
      ...params,
      page: integer(params.page, 1),
    }),
  });

  if (!data) {
    return <UI.PageLoader />;
  }

  const invoices = data.project.invoices.slice((urlState.page - 1) * 12, urlState.page * 12);
  const pageCount = Math.ceil(data.project.invoices.length / 12);

  return (
    <UI.GridContainer>
      <UI.GridContainer sc={{ gutter: 0.5 }}>
        {invoices.length > 0 && (
          <UI.Table>
            <UI.TBody>
              {invoices.map((invoice) => (
                <UI.TR key={invoice.id}>
                  <UI.TD>
                    <UI.A
                      href={`/b/api/invoices/atleta/${invoice.id}`}
                      style={{ textTransform: 'capitalize' }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <UI.Icon>
                        <Download />
                      </UI.Icon>
                      {' '}
                      <UI.Span>
                        {`#${invoice.invoice_id} `}
                      </UI.Span>
                    </UI.A>
                  </UI.TD>
                  <UI.TD>
                    {formatDate(
                      parseDate(invoice.start_date, { format: 'internal_date' }),
                      { format: 'display_month' },
                    )}
                  </UI.TD>
                  {!device.isSmall && (
                    <UI.TD>
                      {invoice.organisation}
                    </UI.TD>
                  )}
                  <UI.TD sc={{ textAlign: 'right', strong: true }}>
                    {formatCurrency(invoice.gross_amount)}
                  </UI.TD>
                </UI.TR>
              ))}
            </UI.TBody>
          </UI.Table>
        )}
        {invoices.length === 0 && t('no_invoices_yet')}
      </UI.GridContainer>
      {pageCount > 1 && (
        <>
          <UI.HR />
          <UI.Pager pageCount={pageCount} />
        </>
      )}
    </UI.GridContainer>
  );
};

export default InvoicesReport;
